import {AManagerApi} from "@/classes/app/api/manager/a-manager-api";

export default class OwnerSubscription extends AManagerApi{
    protected _url: string = '/owner/subscription';
}
